/*
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2023-08-29 15:45:17
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2023-12-19 17:43:02
 * @FilePath: /platform/src/store/user.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import uc from '@/api/uc.js'
import portal from '@/api/portal.js'
import store from '@/store/login'

const state = {
  currentUserDetail: sessionStorage.getItem('currentUserDetail') ? JSON.parse(sessionStorage.getItem('currentUserDetail')) : null,
  allDataDict: sessionStorage.getItem('allDataDict') ? JSON.parse(sessionStorage.getItem('allDataDict')) : [],
  allEnumerate: sessionStorage.getItem('allEnumerate') ? JSON.parse(sessionStorage.getItem('allEnumerate')) : [],
  pwdStrategy: {}, //默认密码策略
  taxTypeList: []
}

const getters = {}

const actions = {
  // 加载当前用户详情
  loadCurrentUserDetail({ commit, state }) {
    const currentUser = store.state.currentUser
    if (currentUser && currentUser.account) {
      return new Promise((resolve, reject) => {
        uc.getUserByAccount(currentUser.account, (resp) => {
          resolve(resp)
          commit('setCurrentUserDetail', resp)
        })
      })
    }
  },
  //获取默认密码策略
  getDefPwdStrategy({ commit, state }) {
    return new Promise((resolve, reject) => {
      uc.getDefPwdStrategy((response) => {
        commit('setPwdStrategy', response)
        resolve(response)
      })
    })
  },
  //获取所有数据字典
  getAllDataDict({ commit }) {
    portal.GETALLDATADICT((response) => {
      commit('GETALLDATADICT', response.data)
    })
  },
  //获取所有数据字典
  getAllEnumerate({ commit }) {
    portal.GETALLENUMSLIST((response) => {
      commit('GETALLENUMSLIST', response.data)
    })
  },
  //获取所有数据字典
  getTaxTypeEnum({ commit }) {
    uc.GETTAXTYPEENUM((response) => {
      commit('GETTAXTYPEENUM', response.data)
    })
  }
}

const mutations = {
  GETALLDATADICT(state, data) {
    sessionStorage.setItem('allDataDict', JSON.stringify(data))
    state.allDataDict = data
  },
  GETALLENUMSLIST(state, data) {
    sessionStorage.setItem('allEnumerate', JSON.stringify(data))
    state.allEnumerate = data
  },
  setCurrentUserDetail(state, data) {
    if (data && data.role && data.role.roleName) {
      data.role = data.role.roleName.split('|')
    }
    sessionStorage.setItem('currentUserDetail', JSON.stringify(data))
    state.currentUserDetail = data
  },
  setPwdStrategy(state, pwdStrategy) {
    state.pwdStrategy = pwdStrategy
  },
  GETTAXTYPEENUM(state, value) {
    state.taxTypeList = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
